export const standardizePhoneNumber = (phone: string) => {
    let value = phone;
    let mobile = value;
    if (value.startsWith('+840')) {
        // remove +840 in phone number
        mobile = value.replace('+840', '+84');
    }
    return mobile;
};
